import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckIcon from '@mui/icons-material/Check';
import LockIcon from '@mui/icons-material/Lock';
import PillBottomIcon from 'src/components/icons/PillBottle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import Star from '@mui/icons-material/StarRounded';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';

import type { PropsWithChildren } from 'react';
import type { TreatmentSupplierIcon } from 'src/packages/polaris/types';
import TeleMedicineIcon from 'src/components/icons/TeleMedicine';

type IconProps = PropsWithChildren<{
  type: TreatmentSupplierIcon;
  containerClassName?: string;
  /** To override default color (blue-50), pass a className here */
  iconClassName?: string;
  /** Must be passed in addition to `iconClassName` to color non-material icons */
  color?: string;
}>;

function TreatmentSupplierIconComponent(props: IconProps) {
  const { children, type, containerClassName, iconClassName, color } = props;

  const containerClasses = `bp-flex bp-h-6 bp-w-6 bp-text-center bp-items-center bp-justify-center bp-rounded-full bp-bg-white ${containerClassName}`;
  const iconClasses = `bp-h-4 bp-w-4 bp-fill-blue-50 ${iconClassName}`;

  switch (type) {
    case 'checkmark':
      return (
        <div className={containerClasses}>
          <CheckIcon className={iconClasses} />
        </div>
      );
    case 'clock':
      return (
        <div className={containerClasses}>
          <ScheduleIcon className={iconClasses} />
        </div>
      );
    case 'cost':
      return (
        <div className={containerClasses}>
          <AttachMoneyIcon className={iconClasses} />
        </div>
      );
    case 'lock':
      return (
        <div className={containerClasses}>
          <LockIcon className={iconClasses} />
        </div>
      );
    case 'noVideo':
      return (
        <div className={containerClasses}>
          <VideocamOffIcon className={iconClasses} />
        </div>
      );
    case 'number':
      return (
        <div className={containerClasses}>
          <Paragraph className="bp-h-4 bp-w-4 !bp-text-xs !bp-text-[#E29727]">{children}</Paragraph>
        </div>
      );
    case 'rxBottle':
      return (
        <div className={`bp-p-[4px] ${containerClasses}`}>
          <PillBottomIcon className={`${iconClassName} bp-fill-none`} color={color} />
        </div>
      );
    case 'star':
      return (
        <div className={containerClasses}>
          <Star className={iconClasses} />
        </div>
      );
    case 'video':
      return (
        <div className={containerClasses}>
          <VideocamIcon className={iconClasses} />
        </div>
      );
    case 'teleMedicine':
      return (
        <div className={`bp-p-[4px] ${containerClasses}`}>
          <TeleMedicineIcon className={`${iconClassName} bp-fill-none`} color={color} />
        </div>
      );
    default:
      return null;
  }
}

export default TreatmentSupplierIconComponent;
